import { datadogRum } from '@datadog/browser-rum';
import config from '../config';

const { datadog } = config;

/**
 * 本番環境（.env.production）かどうかの判定
 * @returns {boolean} true:本番環境, false: それ以外の環境
 */
const isProduction = () => process.env.REACT_APP_PROJECT_NAME === 'production';

/**
 * RUMの初期設定・収集開始
 */
export const startSessionReplayRecording = () => {
  if (!isProduction()) {
    return;
  }

  datadogRum.init({
    applicationId: datadog.applicationId,
    clientToken: datadog.clientToken,
    site: datadog.site,
    service: datadog.service,
    env: datadog.env,
    version: datadog.version,
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: datadog.defaultPrivacyLevel,
  });
  datadogRum.startSessionReplayRecording();
};

/**
 * RUMユーザー情報設定
 * @param {number} operatorId オペレータID
 */
export const setUser = operatorId => {
  if (!isProduction()) {
    return;
  }

  datadogRum.setUser({
    id: operatorId,
  });
};
